export default __webpack_public_path__ + "static/media/product-app-3.a6c719b4.png";